import toast, { ToastPosition } from 'react-hot-toast';
import { v4 as uuid } from 'uuid';

interface IErrorToastProps {
  className?: string;
  duration?: number;
  position?: ToastPosition;
  toastMessage: string;
}

export function ErrorToast({
  duration = 5000,
  position = 'top-right',
  toastMessage,
}: IErrorToastProps) {
  return toast.error(toastMessage, {
    id: uuid(),
    position,
    iconTheme: {
      primary: '#FFF',
      secondary: '#dc4f4f',
    },
    duration,
    style: {
      background: '#dc4f4f',
      padding: '.75rem 1.25rem',
      color: '#FFF',
    },
  });
}
